module.exports = __webpack_public_path__ + "img/public/AdminIcons/subArrowIcon.svg?9a9f9ba0";